import React, { useState, useEffect } from 'react'
import Wait from '@react/react-spectrum/Wait'
import { Image } from '@react/react-spectrum/Image'

export default function ImageWait ({
    className,
    src,
    alt,
    caption,
    timeout,
    onLoad
}) {
    const [wait, setWait] = useState(true)

    useEffect(() => {
        let timerId
        if (wait && timeout) {
            timerId = setTimeout(() => {
                setWait(false)
            }, timeout)
        }

        return () => { // cleanup
            if (timerId) {
                clearTimeout(timerId)
            }
        }
    }, [wait, timeout])

    return (
        <React.Fragment>
            <Image onLoad={() => setWait(false)} className={className} src={src} alt={alt}/>
            {wait &&
          <div className="spinner">
              <Wait centered variant="overBackground" />
              <div className="caption">
                  {caption}
              </div>
          </div>
            }
        </React.Fragment>
    )
}
